export default "__VITE_ASSET__DYaTe7AE__"